import Highway from '@dogstudio/highway'
import modular from 'modujs'

import * as modules from './modules'
import FadeTransition from './modules/FadeTransition'
import Scroller from './modules/Scroller'
import SearchNavigation from './modules/SearchNavigation'
import { setHeaderHeight } from './utils/dom'
import { initPrefetch, refreshPrefetch } from './utils/prefetch'
import { classesInjection, rewriteLinks } from './utils/transitions'


new Scroller()

const Modular = modular
const app = new Modular({
  modules
})

class DefaultRenderer extends Highway.Renderer {
  onEnterCompleted () {
    refreshPrefetch()
    rewriteLinks()

    app.init(app)
    return this
  }

  onLeaveCompleted () {
    app.destroy()
    return this
  }
}

const init = () => {
  classesInjection()
  setHeaderHeight()
  initPrefetch()


  const H = new Highway.Core({
    renderers: {
      default: DefaultRenderer
    },
    transitions: {
      default: FadeTransition
    }
  })

  H.on('NAVIGATE_IN', ({ trigger }) => {
    app.destroy()
    window.lenis.start()
    if (trigger !== 'popstate') {
      window.lenis.scrollTo(0, {
        lock: true,
        immediate: true
      })
    }
  })

  window.H = H
  new Scroller()
  new SearchNavigation()
}

document.addEventListener('DOMContentLoaded', init)
